export default function reload() {
  const isClient = typeof window !== 'undefined';
  if (!isClient) {
    return;
  }

  window.location.reload();
}
